import { StyleSheet } from 'aphrodite/no-important';
import constants from '../../../constants/styles';
let {
  SUCCESS_STATUS_COLOR,
  DANGER_STATUS_COLOR,
  SUCCESS_STATUS_COLOR_HOVER,
  DANGER_STATUS_COLOR_HOVER
} = constants;

let styles = {
  base: {
    display: 'flex',
    boxSizing: 'border-box',
    flexDirection: 'column',
    alignItems: 'flex-start',
    padding: 28,
    width: 400,
    maxWidth: '100%'
  },
  text: {
    textAlign: 'center',
    width: '100%',
    fontSize: '16px'
  },
  p: {
    margin: '4px 0'
  },
  actions: {
    display: 'flex',
    justifyContent: 'center',
    boxSizing: 'border-box',
    padding: '20px 0 0',
    width: '100%'
  },
  btn: {
    marginRight: 4,
    ':last-child': {
      marginRight: 0
    }
  },
  confirm: {
    backgroundColor: SUCCESS_STATUS_COLOR,
    ':hover': {
      backgroundColor: SUCCESS_STATUS_COLOR_HOVER
    }
  },
  deny: {
    backgroundColor: DANGER_STATUS_COLOR,
    ':hover': {
      backgroundColor: DANGER_STATUS_COLOR_HOVER
    }
  },
  icon: {
    fontSize: 12,
    marginRight: 4
  }
};

export default StyleSheet.create(styles);



// WEBPACK FOOTER //
// ./src/components/common/confirmation/Confirmation.styles.js